export default __webpack_public_path__ + "static/media/museu-oscar-niemeyer.3c8ebd18.jpg";